import React, { useEffect, useState } from "react";
import AdminSidebar from "../components/AdminSidebar";
import AdminNavbar from "../components/AdminNavbar";
import AdminAPI from "../../services/adminApi";

function AdminDashboard() {
  const [stats, setStats] = useState({
    totalFarmers: 0,
    activeCycles: 0,
    todayChecklists: 0,
    totalPhotos: 0
  });

  const [farmers, setFarmers] = useState([]);

  useEffect(() => {
    fetchDashboard();
  }, []);

  const fetchDashboard = async () => {
    try {
      const res = await AdminAPI.get("/dashboard");
      setStats(res.data.stats);
      setFarmers(res.data.recentFarmers);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="d-flex">
      <AdminSidebar />

      <div
        style={{
          flex: 1,
          background: "#f5f7fa",
          minHeight: "100vh",
          padding: "20px"
        }}
      >
        <AdminNavbar />

        <div className="row mt-4 g-4">
          <div className="col-md-3">
            <div className="card shadow border-0 p-4">
              <h6>Total Farmers</h6>
              <h2>{stats.totalFarmers}</h2>
            </div>
          </div>

          <div className="col-md-3">
            <div className="card shadow border-0 p-4">
              <h6>Active Cycles</h6>
              <h2>{stats.activeCycles}</h2>
            </div>
          </div>

          <div className="col-md-3">
            <div className="card shadow border-0 p-4">
              <h6>Today's Checklists</h6>
              <h2>{stats.todayChecklists}</h2>
            </div>
          </div>

          <div className="col-md-3">
            <div className="card shadow border-0 p-4">
              <h6>Total Photos</h6>
              <h2>{stats.totalPhotos}</h2>
            </div>
          </div>
        </div>

        <div className="card shadow border-0 mt-4">
          <div className="card-body">
            <h4>Recent Farmer Registrations</h4>

            <table className="table mt-3">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Mobile</th>
                  <th>Village</th>
                  <th>Status</th>
                </tr>
              </thead>

              <tbody>
                {farmers.map((farmer) => (
                  <tr key={farmer.id}>
                    <td>{farmer.full_name}</td>
                    <td>{farmer.email}</td>
                    <td>{farmer.mobile}</td>
                    <td>{farmer.village}</td>
                    <td>
                      <span className="badge bg-success">
                        {farmer.status}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminDashboard;